module.exports = __webpack_public_path__ + "img/bgg.639f1e3d.jpg";